import { VPOCombinedActionsAction, VPOCombinedActionsTypes } from './actions';

interface VPOCombinedActionsState {
  data: any[];
  loading: boolean;
  error: string | null;
  pagination: any;
}

const initialState: VPOCombinedActionsState = {
  data: [],
  loading: false,
  error: null,
  pagination: {},
};

export const vpoCombinedActions = (
  state = initialState,
  action: VPOCombinedActionsAction
): VPOCombinedActionsState => {
  switch (action.type) {
    case VPOCombinedActionsTypes.FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case VPOCombinedActionsTypes.FETCH_SUCCESS:
      const { data: responseData, append } = action.payload;
      return {
        ...state,
        data: append ? [...state.data, ...(responseData.data || [])] : (responseData.data || []),
        pagination: responseData.pagination || {},
        loading: false,
        error: null,
      };

    case VPOCombinedActionsTypes.FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case VPOCombinedActionsTypes.CLEAR_DATA:
      return { ...state, data: [], pagination: {} };

    default:
      return state;
  }
};